// import { useParams } from 'react-router-dom';
// import { useEffect } from 'react';
// import { baseUrl } from '../../config';

// const GoRedirect = () => {
//   const { code } = useParams();

//   useEffect(() => {
//     const fetchUrl = async () => {
//       try {
//         const res = await fetch(`${baseUrl}/link/resolve/${code}`);
//         const data = await res.json();

//         if (data.longUrl) {
//           window.location.href = data.longUrl;
//         } else {
//           window.location.href = '/404';
//         }
//       } catch (err) {
//         console.error(err);
//         window.location.href = '/404';
//       }
//     };

//     fetchUrl();
//   }, [code]);

//   return      <div style={{
//     height: "100vh",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center"
// }}>
//     <p>Redirecting...</p>
// </div>
// };

// export default GoRedirect;


import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { baseUrl } from '../../config';

const GoRedirect = () => {
  const { code } = useParams();

  useEffect(() => {
    const fetchUrl = async () => {
      try {
        const res = await fetch(`${baseUrl}/link/resolve/${code}`);
        const data = await res.json();

        if (data.longUrl) {
          window.location.href = data.longUrl;
        } else {
          window.location.href = '/404';
        }
      } catch (err) {
        console.error(err);
        window.location.href = '/404';
      }
    };

    fetchUrl();
  }, [code]);

  const containerStyle = {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f9fafb",
  };

  const spinnerStyle = {
    width: "50px",
    height: "50px",
    border: "6px solid #e5e7eb",
    borderTop: "6px solid #3b82f6",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: "12px",
  };

  const textStyle = {
    fontSize: "1.2rem",
    color: "#374151",
    fontWeight: 500,
  };

  return (
    <div style={containerStyle}>
      <div style={spinnerStyle}></div>
      <p style={textStyle}>Redirecting...</p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default GoRedirect;
